export class AwsRedshiftResource {
    'clusterIdentifier';
    'clusterType';
    'nodeType';
    'numberOfNodes';
    'status';
    'endpoint';
    'endpointPort';
    'dbName';
    'vpcId';
    'encrypted';
    'kmsKeyId';
    'name';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "clusterIdentifier",
            "baseName": "clusterIdentifier",
            "type": "string",
            "format": ""
        },
        {
            "name": "clusterType",
            "baseName": "clusterType",
            "type": "AwsRedshiftResourceClusterTypeEnum",
            "format": ""
        },
        {
            "name": "nodeType",
            "baseName": "nodeType",
            "type": "string",
            "format": ""
        },
        {
            "name": "numberOfNodes",
            "baseName": "numberOfNodes",
            "type": "number",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        },
        {
            "name": "endpoint",
            "baseName": "endpoint",
            "type": "string",
            "format": ""
        },
        {
            "name": "endpointPort",
            "baseName": "endpointPort",
            "type": "number",
            "format": ""
        },
        {
            "name": "dbName",
            "baseName": "dbName",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpcId",
            "baseName": "vpcId",
            "type": "string",
            "format": ""
        },
        {
            "name": "encrypted",
            "baseName": "encrypted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "kmsKeyId",
            "baseName": "kmsKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsRedshiftResource.attributeTypeMap;
    }
    constructor() {
    }
}
export var AwsRedshiftResourceClusterTypeEnum;
(function (AwsRedshiftResourceClusterTypeEnum) {
    AwsRedshiftResourceClusterTypeEnum["Provisioned"] = "provisioned";
    AwsRedshiftResourceClusterTypeEnum["Serverless"] = "serverless";
})(AwsRedshiftResourceClusterTypeEnum || (AwsRedshiftResourceClusterTypeEnum = {}));
